module.exports = __webpack_public_path__ + "static/media/basketIcon.f2188204.svg";